module.exports = __webpack_public_path__ + "static/media/primarycare.73185db8.jpg";